module.exports = __webpack_public_path__ + "fonts/Quarca-NorReg.9cc603a0.woff";